// src/plugins/lang.js
import { createI18n } from 'vue-i18n'
import enGB from '../lang/en-GB.json'
import enUS from '../lang/en-US.json'
import dateTimeFormats from '../lang/datetime.json'

const browserLocale = navigator.language || navigator.userLanguage || 'en-GB'
const locale = ['en-GB', 'en-US'].includes(browserLocale) ? browserLocale : 'en-GB'

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en-GB',
  messages: {
    'en-GB': enGB,
    'en-US': enUS,
  },
  datetimeFormats: dateTimeFormats,
})

export default i18n